import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { MailWarning, X } from "lucide-react";

/** Banner "Verifica la tua email" — mostrato in cima all'app se l'utente non ha ancora verificato. */
export default function VerifyEmailBanner() {
  const { user, refresh } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  if (!user) return null;
  if (user.email_verified) return null;
  if (user.is_blocked_by_email) return null; // dopo 48h la BlockScreen prende il sopravvento
  if (dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Email di verifica reinviata. Controlla la casella (e lo spam).");
      if (refresh) refresh();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Impossibile reinviare");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-secondary/10 border-b border-secondary/20 text-secondary-foreground/90" data-testid="verify-email-banner">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-2.5 flex items-center gap-3 text-sm">
        <MailWarning className="w-4 h-4 text-secondary flex-shrink-0" />
        <span className="flex-1 min-w-0">
          <strong className="text-secondary">Verifica la tua email</strong> — abbiamo mandato un link a <span className="font-medium">{user.email}</span>. Controlla la casella (e lo spam).
        </span>
        <button
          type="button"
          onClick={resend}
          disabled={sending}
          className="text-xs font-semibold text-secondary hover:underline disabled:opacity-50"
          data-testid="verify-banner-resend"
        >
          {sending ? "Invio…" : "Reinvia email"}
        </button>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="text-secondary/60 hover:text-secondary"
          data-testid="verify-banner-dismiss"
          aria-label="Chiudi banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
